<template>
    <div>
      <p class="ArticleNormal">
        “雨凝烟，青山做宣，烟雨画江南。水无恙，巍巍钱塘，碧水隐空帆。”绝美的歌词，灵动的声线，一首《江上行》勾勒出了钱塘江的大气与优雅。
      </p>
      <p class="ArticleNormal">
        这是今年钱塘江文化节“云尚汇”的主题曲，创作者是在抖音拥有732万粉丝的@一个大金意。他们是浙江音乐学院流行演唱专业大二的学生，四个人因在宿舍里组团“唱歌”而走红抖音。而这一次，他们担任起了传递钱塘江文化的使者。
      </p>
      <video src="../../../assets/1st/Articles/Article_9/video_1.mp4" controls poster="../../../assets/1st/Articles/Article_9/poster_1.jpg"></video>
      <p class="ArticleNormal">
        提起钱塘江文化节，每一个浙江人都不会陌生。
      </p>
      <p class="ArticleNormal">
        钱塘江畔，潮声阵阵。在江边信步闲逛，你会真切地感受到所谓的“钱塘自古繁华”。自2017年以来，浙江省、杭州市、江干区三方联动，以杭州钱塘江文化节为载体，通过“音舞诗、赛展会”等多元方式，展现钱塘江“弄潮儿”的精神。三年以来，钱塘江文化节已然成为杭州市文化的金名片之一。
      </p>
      <p class="ArticleNormal">
        而受黑天鹅事件的影响，“集聚受限、场馆受限、演出受限”大型活动都被迫延期。那今年的文化节“办”，还是“不办”？
      </p>
      <p class="ArticleNormal">
        经过外部的广泛意见征集和内部的多轮商议，钱塘江文化节组委会最终决定“办”！那到底怎么“办”？
      </p>
      <p class="ArticleHead">
        26轮沟通后<br>
        线下的钱塘江文化节搬到了线上
      </p>
      <p class="ArticleNormal">
        “万物皆可直播”的年代，“上云”已成为各大城市展现风采的新玩法。线上展览、线上音乐节等，已成为城市“种草”更多年轻人的不二选择。这让善于拥抱创新的钱塘江文化节组委会找到了答案——“线上办！”。
      </p>
      <p class="ArticleNormal">
        “虽然，之前的钱塘江文化节属于线下参与型的节庆活动，但特殊时期，为什么不能试试在线上办节呢？”文化节组委会相关负责人说到，“既能借新媒体尤其短视频迅速兴起之力，又能打造平台的首个云上文化节，让钱塘江文化借助云端传播走得更远。”
      </p>
      <p class="ArticleNormal">
        由此，打造一场钱塘江文化“云尚汇”的创新构想便催生了。“云尚汇”，也即以抖音平台为阵地，用“短视频+直播”的全新内容呈现形式，打造“云享、云观、云游、云街”四大主题，落地这场文化的盛筵。一方面展现文化节最新的风貌，同时也汇聚沉淀多年来文化节的经典内容。
      </p>
      <img src="../../../assets/1st/Articles/Article_9/contant_1.jpg"/>
      <p class="ArticleNormal">
        在线上进行城市形象传播，广大网友的认可至关重要。但把文化节搬到线上，如何才能既保留文化节的“正统”气质，又能吸引年轻人的关注刷屏？“鱼和熊掌”，如何才能实现兼得？
      </p>
      <p class="ArticleNormal">
        为此，文化节组委会与巨量引擎浙江分公司先后开展了26轮沟通。回忆当初的合作过程，“云尚汇”项目负责人巨量引擎张莹说到：“如果只是做线上的音乐歌舞，相比与往年就没有升级的亮点，难以形成出圈的效应；但如果仅仅联动抖音达人，则又无法凸显活动的文化底蕴。”
      </p>
      <p class="ArticleNormal">
        经过多轮探讨后，“传承与创新”成为这场特殊文化节的突破口。组委会最终决定打造一场“立体化”的文化节。一方面，延续文化节本身高端的品质感；另一方面，决定将内容的触角延伸到年轻人感兴趣的各个文化领域，包括音乐、舞蹈、美食、本地生活等等。
      </p>
      <p class="ArticleHead">
        文化大咖+网红创作者组团“云享”美好<br>
        共筑一场出圈的线上文化节
      </p>
      <p class="ArticleNormal">
        为了保证文化节“纯正的血统”，活动成功邀请到了多个领域的大咖，包括文学领域的中国文联副主席陈振濂，话剧领域的中国剧协副主席王晓鹰，音乐领域的中国音协副主席关峡、中国曲协副主席翁仁康、歌手叶炫清，财经领域的作家吴晓波等10位文化名人，在线对话，分享钱塘江的历史底蕴与精神气质。
      </p>
      <p class="ArticleNormal">
        同时，活动还邀请到抖音粉丝3961万+的@李子柒 在线打call。此外，还有抖音本地达人@杭州小黑诸鸣，结合古典名著与历史冷知识中的钱塘江佳话，将钱江文化种草向万千网友，@江湛同学 则从“远近高低各不同”的缤纷视角入手，为大家娓娓道来满载魅力的钱江那些事儿。
      </p>
      <p class="ArticleNormal">
        各个领域的专家和名人，既保证了文化节的文化广度与深度，又能吸引各个圈层的爱好者。凭借着“豪华而立体”的嘉宾阵容，此次文化节的直播成功吸引了近40万观众见证文化节“云”启幕。与此同时，“云尚汇”还结合杭州特色地标，设计“弄潮儿”形象的趣味贴纸，激发了全网用户的参与。
      </p>
      <p class="ArticleNormal">
        除了直播和云享环节，文化节还在抖音平台搭建起了“云观、云游、云街”三大板块。
      </p>
      <p class="ArticleNormal">
        “云观”，纵览了三年来钱塘江文化节的文化成果，沉淀出了一场顶级视听的盛筵。在交响《钱江潮》的音乐里感受钱江潮滚滚而来的气势恢宏。而“云游”里，如诗如画的钱江尽收眼底，舌尖上的美食挑逗着味蕾。“云街”则从第一视角带你走街串巷，从非物质文化蛋雕传承人到海塘遗址博物馆，放慢脚步，带你体验城市的慢生活。
      </p>
      <div>
        <img class="Img4" src="../../../assets/1st/Articles/Article_9/contant_2.png"/>
        <img class="Img4" src="../../../assets/1st/Articles/Article_9/contant_3.png"/>
        <img class="Img4" src="../../../assets/1st/Articles/Article_9/contant_4.png"/>
        <img class="Img4" src="../../../assets/1st/Articles/Article_9/contant_5.png"/>
      </div>
      <p class="ArticleNormal">
        如果说直播是一场“高光秀”，那云享、云观、云游、云街则是在抖音搭建起的长期影响阵地，为文化节打造了常态化的运营与展示魅力的窗口。截至7月底，“云尚汇”平台累计播放量达3亿次，发布视频4.8万支，观众点赞超过502万，留言达56.4万条。
      </p>
      <p class="ArticleHead">
        直播引爆+短视频沉淀<br>
        一场“永不落幕”的文化节
      </p>
      <p class="ArticleNormal">
        钱塘江文化“云尚汇”的成功上线，让钱塘江文化借助新媒体的力量，实现了内容创新力和社会影响力的再度攀升。
      </p>
      <p class="ArticleNormal">
        值得一提的是，“云尚汇”在抖音搭建的聚合性平台，实现了文化节从“单一性、集聚性、短期性”的文化参与，到“多元性、即时性、长期性”的文化体验突破。不仅打造了一场“永不落幕的云上文化节”，也为城市文化名片塑造树立了可谓标杆的案例。
      </p>
      <p class="ArticleNormal">
        巨量引擎浙江分公司总经理王雪芹看来，这次的钱塘江文化节是一次“短视频+直播”组合拳成功的尝试，巧妙地整合了两种形式的优势，“一方面用短视频吸引关注、积蓄流量；另一方面在直播间聚焦钱塘江文化软实力，通过邀请文化名人、明星、达人等强势背书。最终，让这座城市的气质和特征得到‘点→线→面’的强曝光，有效强化了城市印象。”
      </p>
      <p class="ArticleNormal">
        连续四年来，钱塘江文化节的成功落地，成功打破了千城一面的难题。这次和抖音平台的合作，是文化节组委会善于拥抱变化，敢于危中寻机的结果。而3亿声量的破圈成就，则离不开其对城市特色的深度挖掘，以及对传播载体、传播时机的有效掌控。
      </p>
    </div>
</template>

<script>
    export default {
        name: "Article9"
    }
</script>

<style scoped>
  img{
    width: 100%;
  }
  video{
    width: 100%;
  }
  .Img4{
    width: 25%;
    display: block;
    float: left;
    margin-bottom: 3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/Articles/Article9.vue